import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { useTranslate } from 'react-admin';
import CustomSelectArrayInput from '@/components/global/inputs/CustomSelectArrayInput.jsx';
import { analyticsStyles } from '@/themes/commonStyles/analytics.js';
import { Palette } from '@/themes/themeOverrides/Palette';
import { getAdStatusChoices } from '@/constants/AdStatus.js';

const StyledStatusForm = styled(Box)(() => ({
    ...analyticsStyles.periodInput,
    position: 'relative',
    marginBottom: 0,
    '& .custom-select-array-input': {
        width: '100%',
        '& .MuiFormControl-root.MuiFormControl-marginDense': {
            borderRadius: '12px',
            border: `2px solid ${Palette.gray.gray200}`,
            '&.active': {
                borderColor: Palette.black,
                boxShadow: `0 0 0 2px ${Palette.yellow.yellow200}`,
            },
            '& svg': {
                right: '8px',
                top: '10px',
                display: 'block',
                width: '18px',
            },
        },
    },
    '& .custom-select-array-input .MuiFormControl-root': {
        width: '100%',
    },
    '& .custom-select-array-input .checkboxes-filter__popup': {
        left: 0,
        right: 0,
        top: 'calc(100% + 2px)',
        width: '100% !important',
    },
}));

export const StatusFilterInput = ({ label, emptyValue }) => {
    const translate = useTranslate();
    const defaultLabel = label || translate('common.status');

    const statusChoices = getAdStatusChoices(translate);

    return (
        <StyledStatusForm className='status-form filter-field'>
            <CustomSelectArrayInput
                source='status_in'
                choices={statusChoices}
                label={defaultLabel}
                defaultValue={statusChoices.map(choice => choice.id)}
                alwaysDropdown={true}
                emptyValue={emptyValue}
            />
        </StyledStatusForm>
    );
};

StatusFilterInput.propTypes = {
    label: PropTypes.string,
    emptyValue: PropTypes.string,
};
